import { useEffect, useState } from "react";
import { db } from "../firebase";
import {
  collection,
  getDocs,
} from "firebase/firestore";

function TopWithdraw() {
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    try {
      // 🔥 withdraw requests
      const snap = await getDocs(collection(db, "withdraw_requests"));

      const map = {};

      snap.forEach((doc) => {
        const d = doc.data();

        if (d.status !== "approved") return;

        const uid = d.userId;;

        if (!map[uid]) {
          map[uid] = 0;
        }

        map[uid] += d.amount || 0;
      });

      // 🔥 convert to array
      let arr = Object.keys(map).map((uid) => ({
        uid,
        totalWithdraw: map[uid],
      }));

      // 🔥 sort desc
      arr.sort((a, b) => b.totalWithdraw - a.totalWithdraw);

      // 🔥 limit 20
      arr = arr.slice(0, 20);

      // 🔥 get user data
      const usersSnap = await getDocs(collection(db, "users"));

      const userMap = {};
      usersSnap.forEach((doc) => {
        userMap[doc.id] = doc.data();
      });

      const final = arr.map((u) => ({
        ...u,
        name: userMap[u.uid]?.name || "User",
        email: userMap[u.uid]?.email || "",
      }));

      setUsers(final);

    } catch (e) {
      console.error(e);
    }
  };

  // 🔍 SEARCH
  const filtered = users.filter((u) => {
    const s = search.toLowerCase();

    return (
      (u.name || "").toLowerCase().includes(s) ||
      (u.email || "").toLowerCase().includes(s) ||
      (u.uid || "").toLowerCase().includes(s)
    );
  });

  return (
    <div style={container}>
      <h1>💸 Top Withdraw Users</h1>

      <input
        placeholder="🔍 Search name / email / UID"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        style={searchBox}
      />

      <div style={grid}>
        {filtered.map((u, i) => (
          <div key={u.uid} style={card}>
            <h3>#{i + 1} {u.name}</h3>
            <p>{u.email}</p>
            <p>🆔 {u.uid}</p>

            <p style={amount}>
              💸 ₹{u.totalWithdraw}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}

/* STYLES */

const container = {
  padding: 20,
  color: "white",
  background: "linear-gradient(135deg, #0F1221, #0A0D1A)",
  minHeight: "100vh",
};

const searchBox = {
  width: "100%",
  padding: 10,
  borderRadius: 10,
  border: "1px solid rgba(255,255,255,0.1)",
  background: "#1A1F2E",
  color: "#fff",
  marginBottom: 20,
};

const grid = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
  gap: 20,
};

const card = {
  background: "#1A1F2E",
  padding: 16,
  borderRadius: 12,
};

const amount = {
  marginTop: 10,
  fontWeight: "bold",
  color: "#ef4444",
};

export default TopWithdraw;